<template>
    <div id="my-messages" :class="{hasTrialAlert: showTrialAlert}">
        <Loader v-if="loading" class="mt-5"/>
        <div 
            v-else-if="!rooms.length"
            class="d-flex align-items-center justify-content-center mx-auto">
            <MessagesZero/>
        </div>
        <div v-else class="my-messages">
            <Rooms
                :rooms="rooms"
                :room="room"
                @roomChange="room = $event"/>
            <Messages 
                :empty-chat = "isEmptyChat" 
                v-if="room && room.id"
                :room="room"/>
        </div>
    </div>
</template>

<script>
import { MessagesZero, Loader } from '../../components/Icons'
import Rooms from './Rooms'
import Messages from './Messages/index.vue'
import { useRooms, useRouter, useStore} from '../../core/hooks'
import { ref, watch, computed } from '@vue/composition-api'

export default {
    name: 'Chat',
    components: {
        MessagesZero,
        Loader,
        Rooms,
        Messages,
    },
    setup: function () {
        const { rooms, room } = useRooms()
        const { store } = useStore()
        const {route} = useRouter()

        let loading = ref(true)
        watch(rooms, (rooms) => {
            if(rooms) {
                loading.value = false
            }
        }, {immediate: true})

        const isEcommercePlatform = computed(() => store.getters.isEcommercePlatform)
        const showTrialAlert = computed(() => store.getters.hasTrial && !store.getters.membershipStatus)

        const isEmptyChat = computed(() => {
            const currentRoom = rooms.value.find(item => item.id === route.value.query.roomId);
            return currentRoom && !currentRoom.lastMessage.message
        })

        return {
            rooms,
            room,
            loading,
            isEmptyChat,
            showTrialAlert,
            isEcommercePlatform
        }
    }
}
</script>
<style lang="scss" scoped>
div#my-messages {
    height: calc(100vh - 135px);
    padding: 32px;
    display: flex;
    align-items: center;

    &.hasTrialAlert {
        height: calc(100vh - 180px);
    }

    div.my-messages {
        width: 100%;
        height: 100%;
        border-radius: 12px;
        background: #ffffff;
        display: flex;
    }   
}
</style>